import { appLocalStorage } from '@/app/shared/commonURLs';

let BONotificationUrl = appLocalStorage.BONotificationUrl;
let BONotificationODataUrl = appLocalStorage.BONotificationODataUrl;
let BONotificationWebSocketUrl = appLocalStorage.BONotificationWebSocketUrl;
let NotificationBaseUrl = appLocalStorage.NotificationBaseUrl;

export class Urls {
    constructor() {
        this.NotificationBaseUrl = NotificationBaseUrl;
        this.NotificationServicesList = NotificationUrls();
        this.BONotificationWebSocketList = BONotificationWebSocketUrls();
    }
}

const NotificationUrl = new Urls();

export { NotificationUrl };

function NotificationUrls() {
    var services = {};

    services["GetUpdatedTicket"] = {
        Method: 'GET',
        URL: BONotificationUrl + 'UserTicket/GetUpdatedTicket',
    };
    
    services["MarkUserNotificationsPerEntityAsRead"] = {
        Method: 'PUT',
        URL: BONotificationUrl + 'ClientsNotification/MarkUserNotificationsPerEntityAsRead',
    };
    
    services["GetUnreadUserNotifactionsPerEntityCount"] = {
        Method: 'GET',
        URL: BONotificationUrl + 'ClientsNotification/GetUnreadUserNotifactionsPerEntityCount',
    };

    //
    //OData
    //
    services["GetNotificationOData"] = {
        Method: 'GET',
        URL: BONotificationODataUrl + 'NotificationOData?',
    };

    return services;
}

function BONotificationWebSocketUrls() {
    var services = {};

    services["Connect"] = {
        Method: 'GET',
        URL: BONotificationWebSocketUrl + 'ClientsNotificationWS/Connect',
    };

    return services;
}